export default {
  'career.title': 'Career',
  'career.titleHighlight': 'History',
  'career.subtitle': 'これまでの経歴と学歴',

  // Sections
  'career.business.title': 'Business',
  'career.education.title': 'Education',
  'career.skills.title': 'Technical Skills',
  'career.skills.description': 'I cover wide range of software skills.',

  // Status labels
  'career.status.enrolled': '在学中',
  'career.status.completed': '修了',
  'career.status.graduated': '卒業',

  // Business Career
  'career.business.nvidia.company': 'NVIDIA合同会社',
  'career.business.nvidia.position': 'シニアソリューションアーキテクト',
  'career.business.unity.company': 'Unity Technologies Japan株式会社',
  'career.business.unity.position': 'シニアプログラムマネージャー',
  'career.business.playlife.company': '株式会社Play Life Studio',
  'career.business.playlife.position': '代表取締役',
  'career.business.hakuhodo.company': '株式会社博報堂',
  'career.business.hakuhodo.position': '研究ディレクター',
  'career.business.ricoh.company': '株式会社リコー',
  'career.business.ricoh.position': 'プロジェクトマネージャー / ソフトウェアエンジニア',
  'career.business.squareenix.company': '株式会社スクウェア・エニックス',
  'career.business.squareenix.position': 'ゲームプログラマー',
  'career.business.sony.company': 'ソニー株式会社',
  'career.business.sony.position': 'ソフトウェアエンジニア',

  // Education
  'career.education.utokyo.institution': '東京大学大学院',
  'career.education.utokyo.degree': '学際情報学府 博士課程',
  'career.education.keio_grad.institution': '慶應義塾大学大学院',
  'career.education.keio_grad.degree': 'メディアデザイン研究科 修士課程',
  'career.education.keio.institution': '慶應義塾大学',
  'career.education.keio.degree': '環境情報学部 環境情報学科',
};
